__turbopack_context__.v({
  "active": "styles-module__UPa_rW__active",
  "button": "styles-module__UPa_rW__button",
  "closeButton": "styles-module__UPa_rW__closeButton",
  "fixed": "styles-module__UPa_rW__fixed",
  "notificationContainer": "styles-module__UPa_rW__notificationContainer",
});
